import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getSchools } from '../../../api/schools';
import { PageHeader } from '../../../components/layout/PageHeader';
import { DataTable } from '../../../components/ui/DataTable';
import { StatusBadge } from '../../../components/ui/StatusBadge';
import { Sparkles } from 'lucide-react';
const typeColors = {
    maternelle: 'bg-pink-100 text-pink-700',
    elementaire: 'bg-blue-100 text-blue-700',
    primaire: 'bg-purple-100 text-purple-700',
    college: 'bg-indigo-100 text-indigo-700',
    lycee_general: 'bg-amber-100 text-amber-700',
    lycee_pro: 'bg-amber-100 text-amber-700',
    lycee_polyvalent: 'bg-amber-100 text-amber-700',
    lycee_technique: 'bg-amber-100 text-amber-700',
    other: 'bg-gray-100 text-gray-700',
};
const TYPE_LABELS = {
    maternelle: 'Maternelle',
    elementaire: 'Élémentaire',
    primaire: 'Primaire',
    college: 'Collège',
    lycee_general: 'Lycée général',
    lycee_pro: 'Lycée pro',
    lycee_polyvalent: 'Lycée polyvalent',
    lycee_technique: 'Lycée technique',
    other: 'Autre',
};
export default function SchoolList() {
    const navigate = useNavigate();
    const { data, isLoading } = useQuery({ queryKey: ['admin-schools'], queryFn: getSchools });
    const columns = [
        {
            key: 'name',
            header: 'Nom',
            render: (s) => (_jsxs("div", { children: [_jsxs("div", { className: "font-medium flex items-center gap-2", children: [s.name, (s.is_rep_plus || s.is_rep) && (_jsx("span", { className: "text-[10px] font-semibold px-1.5 py-0.5 rounded bg-orange-100 text-orange-700", children: s.is_rep_plus ? 'REP+' : 'REP' }))] }), _jsx("div", { className: "text-[11px] text-gray-400", children: s.uai })] })),
        },
        { key: 'type', header: 'Type', render: (s) => _jsx(StatusBadge, { status: TYPE_LABELS[s.type] ?? s.type, colorMap: typeColors }) },
        { key: 'status', header: 'Statut', render: (s) => s.status === 'public' ? 'Public' : 'Privé' },
        { key: 'address', header: 'Adresse', render: (s) => _jsx("span", { className: "text-xs text-gray-500", children: s.address ?? '-' }) },
        {
            key: 'has_override',
            header: 'Personnalisation',
            render: (s) => s.has_override ? (_jsxs("span", { className: "inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700", children: [_jsx(Sparkles, { size: 12 }), " Personnalis\u00E9e"] })) : (_jsx("span", { className: "text-xs text-gray-400", children: "R\u00E9f\u00E9rentiel uniquement" })),
        },
        { key: 'menu_count', header: 'Menus', render: (s) => s.menu_count },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "Vie scolaire", subtitle: `${data?.total ?? 0} établissement(s) référencé(s) pour votre commune` }), data && data.total === 0 && !isLoading && (_jsxs("div", { className: "bg-amber-50 border border-amber-200 text-amber-800 text-sm rounded-lg p-4 mb-4", children: ["Aucune \u00E9cole n'est r\u00E9f\u00E9renc\u00E9e dans l'annuaire de l'\u00E9ducation pour votre commune. V\u00E9rifiez que votre commune est bien li\u00E9e au r\u00E9f\u00E9rentiel ", _jsx("code", { children: "geo_communes" }), "."] })), _jsx(DataTable, { columns: columns, data: data?.data ?? [], isLoading: isLoading, rowKey: (s) => s.uai, onRowClick: (s) => navigate(`/commune/schools/${s.uai}`) })] }));
}
